export type AuthConfirmationMethod = 'sms' | 'call';

export type UserIdentifierType = 'PHONE';

export interface ResourceAccessToken {
  access_token: string;
}

export interface ApiResponse<T> {
  code: number;
  data?: T;
  message?: string;
}

export interface RequestInitAccountAuth {
  user_identifier_type: UserIdentifierType;
  user_identifier_value: number;
  verification_channel: AuthConfirmationMethod;
  recaptcha_token: string;
}

export interface InitAccountAuthResponse {
  code?: string;
  card_number?: string;
  confirmed: boolean;
}

export interface RequestLoginAccount {
  user_identifier_value: number;
  code: string;
}

export interface RequestCheckAccountCode {
  user_identifier_value: number;
  code: string;
}

export interface ConfirmAccountData {
  email?: string;
  first_name: string;
  fathers_name?: string;
  last_name: string;
  dob: string;
  gender: string;
}

export interface RequestConfirmAccount extends RequestLoginAccount, ConfirmAccountData {}

export interface User {
  id: number;
  first_name: string;
  last_name: string;
  phone_number: string;
  email?: string;
  dob: string;
  gender: string;
  created_at: string;
  updated_at: string;
}

export interface ResourceAccount {
  id: number;
  role: string;
  confirmed: boolean;
  external_id: number;
  invited_by: number;
  digital_card: string;
  registration_bonus_completed_at: string;
  referral_link: string;
  user_professional_profile?: {
    id: number;
    user_id: number;
    store_id: number;
    first_name: string;
    last_name: string;
    fathers_name: string;
    phone: string;
    position: string;
    hired_at: string;
    dob: string;
    working_period: {
      years: number;
      months: number;
    };
  };
  user_questionnaire?: {
    id: number;
    user_id: number;
    phone: string;
    email: string;
    first_name: string;
    last_name: string;
    dob: string;
    gender: string;
    fathers_name: string;
    store_id: number;
    is_print_receipt_at_cash_desk: boolean;
  };
  user_identifiers: Array<{
    id: number;
    user_id: number;
    type: string;
    value: string;
    priority: number;
  }>;
  career: Record<string, unknown>;
}

export interface AuthState {
  isAuthenticated: boolean;
  token: string | null;
  user: User | null;
  isLoading: boolean;
}

export enum RegistrationStep {
  INTRO = 'intro',
  DETAILS = 'details',
}

export enum AuthStatus {
  LOADING = 'loading',
  AUTHENTICATED = 'authenticated',
  UNAUTHENTICATED = 'unauthenticated',
  PHONE_REQUEST = 'phone_request',
  OTP_INPUT = 'otp_input',
  USER_CHECK = 'user_check',
  REGISTRATION_REQUIRED = 'registration_required',
}
